import {
	Component,
	Inject,
	ChangeDetectionStrategy,
	OnInit,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export enum ActionType {
	void = "void",
	discount = "discount",
	guest = "guest",
	price = "price",
	quantity = "quantity",
	transfer = "transfer",
}

export interface KeyBoardData extends KeyboardOptions {
	inputValue: string;
}

// Keyboard Options
export interface KeyboardOptions {
	numericOnly?: boolean;
	action?: ActionType;
	message?: string;
	placeholder?: string;
	inlist?: number[];
	max?: number;
	min?: number;
}

export interface Keyboard {
	text: string;
	value: number;
}
@Component({
	selector: "keyboard-dialog",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ["./keyboard.scss"],
	templateUrl: "./keyboard.html",
})
export class KeyboardDialogComponent implements OnInit {
	errorMessage: string = null;
	keyboards: Keyboard[] = [
		{ text: "1", value: 1 },
		{ text: "2", value: 2 },
		{ text: "3", value: 3 },
		{ text: "4", value: 4 },
		{ text: "5", value: 5 },
		{ text: "6", value: 6 },
		{ text: "7", value: 7 },
		{ text: "8", value: 8 },
		{ text: "9", value: 9 },
		{ text: "0", value: 0 },
	];

	constructor(
		public dialogRef: MatDialogRef<KeyboardDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: KeyBoardData
	) {
		if (data) {
			if (!data.message) {
				data.message = "Enter your number";
			}
			if (!data.placeholder) {
				data.placeholder = "Enter your number";
			}
		}
	}

	ngOnInit() {}

	onNoClick(): void {
		this.dialogRef.close();
	}

	clickOnNumber(keyboard: Keyboard): void {
		const currentValue = Number(this.data.inputValue + keyboard.text);
		if (this.data.max) {
			this.errorMessage = null;
			if (currentValue > this.data.max) {
				this.errorMessage = "Maximum value is " + this.data.max;
				return;
			}
		}
		if (typeof this.data.inputValue === "undefined") {
			this.data.inputValue = keyboard.text;
		} else {
			this.data.inputValue += keyboard.text;
		}
	}

	clickOnDot() {
		if (typeof this.data.inputValue !== "undefined") {
			if ((this.data.inputValue + "").indexOf(",") === -1) {
				this.data.inputValue += ",";
			}
		}
	}

	clear() {
		this.data.inputValue = this.data.inputValue
			? (this.data.inputValue + "").slice(0, -1)
			: "";
		this.errorMessage = null;
	}

	clearAll() {
		this.data.inputValue = "";
		this.errorMessage = null;
	}

	valuechange(e) {
		console.log("keyCode: ", e.keyCode);
	}

	enterKeyboard() {
		this.errorMessage = null;
		if (this.data) {
			const inputValue =
				typeof this.data.inputValue === "string"
					? Number(this.data.inputValue.replace(",", "."))
					: Number(this.data.inputValue);
			if (
				this.data.action === ActionType.discount ||
				this.data.action === ActionType.price
			) {
				this.data.inputValue = (inputValue * 1000).toString();
			}
			if (
				this.data.action === ActionType.quantity ||
				this.data.action === ActionType.void
			) {
				this.data.inputValue = inputValue.toString();
			}
			if (this.data.inlist && this.data.inlist.length > 0) {
				if (this.data.inlist.indexOf(inputValue) > -1) {
					this.dialogRef.close(this.data);
				} else {
					this.errorMessage = "Invalid number input";
				}
			} else {
				this.dialogRef.close(this.data);
			}
		}
	}
}
